import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import Collection from 'assets/components/data/Collection';
import Row from 'assets/components/data/rows/Row';
import RowActions from 'assets/components/data/rows/RowActions';
import RowData from 'assets/components/data/rows/RowData';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import { getLocales } from 'assets/locales/Locale';
import Dealer from 'models/dealerManagement/dealer/Model.Dealer';
import HeaderRow from 'assets/components/data/rows/HeaderRow';
import HeaderData from 'assets/components/data/rows/HeaderData';
import { useProductEnhancementDealerDocumentProvider } from '../ProductEnhancementDocument.DealerDocuments.Hooks';
import ThemeCollectionList from 'assets/components/data/themes/Theme.Collection.List';
import UploadDocumentTranslationButton from 'module/productManagement/components/translations/UploadDocumentTranslationButton';

export default function DealerDocumentList() {
  const { lang } = getLocales();
  const {
    dealerDocumentList,
    selectedItems,
    toggleItem,
    reloadTranslatedDocs,
    selectedTranslatedItems,
    toggleTranslatedItem,
    translatedDocumentList,
  } = useProductEnhancementDealerDocumentProvider();

  return dealerDocumentList.count == 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.documents}
      render={lang.noInfo}
    />
  ) : (
    <Collection class={ThemeCollectionList}>
      <HeaderRow>
        <HeaderData>{lang.dealer}</HeaderData>
        <HeaderData>{lang.document}</HeaderData>
        <HeaderData>{lang.translations}</HeaderData>
        <HeaderData numOfActions={1} />
      </HeaderRow>
      <DataMap
        data={dealerDocumentList.data?.map((x) => ({ ...x, dealer: new Dealer(x.dealer) }))}
        render={({ data: productDealerDocument }) => {
          const isDocumentSelected = selectedItems?.some((it) => it.dealerId === productDealerDocument.dealerId);
          const translations = translatedDocumentList?.filter((it) => it.documentId === productDealerDocument.id) ?? [];
          const areTranslationsSelected = translations?.every((it) =>
            selectedTranslatedItems.some((t) => t.id === it.id)
          );
          return (
            <Row
              key={productDealerDocument.dealerId}
              children={
                <>
                  <RowData {...productDealerDocument.dealer.displayInfo} />
                  <RowData>{productDealerDocument.mediaFile?.name ?? '-'}</RowData>
                  <RowData>
                    <UploadDocumentTranslationButton
                      documentId={productDealerDocument.id}
                      documentType="ProductEnhancementDealerDocument"
                      translatedDocuments={translations}
                      onFinish={reloadTranslatedDocs}
                    />
                  </RowData>
                  <RowActions>
                    <Button
                      data={productDealerDocument}
                      onClick={toggleItem}
                      class={ThemeButtonCircle}
                      media={<Icon class={isDocumentSelected ? 'fas-check-square' : 'far-square'} />}
                      htmlElementProps={{ title: isDocumentSelected ? lang.unselect : lang.select }}
                      active
                    />
                    <Button
                      data={translations}
                      onClick={toggleTranslatedItem}
                      class={ThemeButtonCircle}
                      disabled={isDocumentSelected || !translations?.length}
                      media={
                        <Icon
                          class={
                            (areTranslationsSelected || isDocumentSelected) && translations?.length
                              ? 'fas-check-square'
                              : 'far-square'
                          }
                        />
                      }
                      htmlElementProps={{ title: areTranslationsSelected ? lang.unselect : lang.select }}
                      active
                    />
                  </RowActions>
                </>
              }
            />
          );
        }}
      />
    </Collection>
  );
}
